module.exports = __webpack_public_path__ + "assets/public/imgs/logos/3scale.svg";